import { TimelineLite } from "gsap";
import { DestroyOptions } from "pixi.js";
import { Application } from "../Application";
import * as Constants from "../Data/Constants";
import { Culture } from "../Data/Culture";
import * as Topics from "../Data/Topics";
import * as VO from "../Data/VoiceOver";
import Gameplay from "../Gameplay";
import { Character, CharacterName } from "./Character";
import { InteruptType, VoiceCategory } from "./VoiceOverManager";

let IDLE_TIMEOUT = 25000;
const IDLE_TIMEOUT_2 = 45000;

export default class CharacterManager extends PIXI.Container {
    public get swapComplete(): boolean {
        return this._characterInstrumentsSwapped === this.characters.length;
    }
    public characters: Character[];
    protected _characterInstrumentsSwapped: number = 0;
    private hintTimeOut?: number;
    private readonly _size: PIXI.Point = new PIXI.Point();
    private readonly _messageTokens: any[];

    constructor() {
        super();
        this.characters = new Array<Character>(CharacterName.NumElements);

        const particleOffset = new PIXI.Point(0, 35);
        const inputOffset = new PIXI.Point(10, 450);

        const startingCulture = Gameplay.Instance.currentCulture;
        const andy = new Character(CharacterName.Andy, particleOffset, inputOffset, startingCulture);
        const carmen = new Character(CharacterName.Carmen, particleOffset, inputOffset, startingCulture);
        const leo = new Character(CharacterName.Leo, particleOffset, inputOffset, startingCulture);

        andy.endPosition    = new PIXI.Point(50, -150);
        carmen.endPosition  = new PIXI.Point(200, -80);
        leo.endPosition     = new PIXI.Point(350, -150);

        this.characters[CharacterName.Andy]     = andy;
        this.characters[CharacterName.Carmen]   = carmen;
        this.characters[CharacterName.Leo]      = leo;

        this.addChild(leo, andy, carmen); // order matters

        this._messageTokens = new Array<any>();
        this._messageTokens.push(
            PubSub.subscribe(Topics.CULTURE_CHANGE_BEGIN, this.onCultureChangeBegin.bind(this)),
            PubSub.subscribe(Topics.CULTURE_CHANGE_COMPLETE, this.onCultureChangeComplete.bind(this)),
            PubSub.subscribe(Topics.INSTRUMENT_PULL_OUT_FINISHED, this.onCharacterInstrumentSwapped.bind(this)),
            PubSub.subscribe(Topics.START_INTRO, this.startIntro.bind(this)),
            PubSub.subscribe(Topics.SOLO_REQUESTED, this.restartHintTimer.bind(this)),
            PubSub.subscribe(Topics.SOLO_ENDED, this.restartHintTimer.bind(this)),
        );

        Gameplay.Instance.characterManager = this;

    }

    public destroy(pOptions?: DestroyOptions | boolean) {
        this._messageTokens.forEach(PubSub.unsubscribe);
        Gameplay.Instance.characterManager = undefined;
        super.destroy(pOptions);
    }

    protected startIntro() {
        // const introTimeline: TimelineLite = new TimelineLite();
        const andy      = this.characters[CharacterName.Andy];
        const carmen    = this.characters[CharacterName.Carmen];
        const leo       = this.characters[CharacterName.Leo];

        andy.startIntro();
        carmen.startIntro();
        leo.startIntro();

        // introTimeline
        //     .call(andy.startIntro, [], andy, 0)
        //     .call(leo.startIntro, [], leo, 0)
        //     .call(carmen.startIntro, [], carmen, 0)
        // ;
    }

    protected onCultureChangeComplete(pTopic: string, pData: Culture): void {
        this._characterInstrumentsSwapped = 0;
/*
        for (let i = this.characters.length - 1; i >= 0; --i) {
            this.characters[i].inputEnabled = true;
        }
*/
    }
    protected onCharacterInstrumentSwapped(pTopic: string, pData: CharacterName): void {
        ++this._characterInstrumentsSwapped;
        // console.log("character element swapped " + pData);
        if (this.swapComplete) {
            // console.warn("Change complete - Char");
            PubSub.publishSync(Topics.ALL_INSTRUMENT_SWAPS_COMPLETE, this);
        }
    }
    protected onCultureChangeBegin(pTopic: string, pData: Culture): void {
        // Tell all characters to change culture
        for (let i = this.characters.length - 1; i >= 0; --i) {
            this.characters[i].inputEnabled = false;
            this.characters[i].changeCulture(pData);
        }
    }
    protected playHint() {
        const andy      = this.characters[CharacterName.Andy];
        const carmen    = this.characters[CharacterName.Carmen];
        const leo       = this.characters[CharacterName.Leo];
        const isAnyCharacterClickable = andy.interactive || carmen.interactive || leo.interactive;

        IDLE_TIMEOUT = IDLE_TIMEOUT_2;
        this.restartHintTimer();

        if (!isAnyCharacterClickable) {
            return;
        }

        Application.instance.voiceOver.play(VO.O1, InteruptType.LESS, VoiceCategory.GAMEPLAY);
    }
    private clearHintTimer() {
        clearTimeout(this.hintTimeOut);
        this.hintTimeOut = undefined;
    }

    private startHintTimer() {
        this.hintTimeOut = setTimeout(this.playHint.bind(this), IDLE_TIMEOUT);
    }

    private restartHintTimer() {
        this.clearHintTimer();
        this.startHintTimer();
    }
}
